import React from "react";
import { Link } from "react-router-dom";

export const FormPrivacyNote = ({ className = "" }) => (
  <p data-testid="form-privacy-note" className={`text-xs text-ink-muted ${className}`}>
    We use your details only to deal with this request. See our{" "}
    <Link to="/privacy" className="underline text-bronze-dark">Privacy Notice</Link>.
  </p>
);

export const NoMedicalInfoNote = () => (
  <p data-testid="no-medical-info-note" role="note" className="md:col-span-2 p-4 bg-cream-100 border border-bronze-light/50 rounded-sm text-sm text-ink">
    Please do not include medical information in this form. We will contact you to arrange a secure consultation.
  </p>
);
